var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-login"},[_c('el-container',[_c('el-main',{class:_vm.getMainClass()},[_c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{staticClass:"bg-main"},[_c('router-view')],1)])],1),_c('el-footer',[_c('Footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }